<template>
	<div class="“error-app">
		<div class="error">
			<dl>
				<dt>您访问的链接不存在！</dt>
				<dd>
					倒计时
					<em id="time">{{ time }}</em> 秒后将为你自动跳转首页！
				</dd>
				<p>
					<!-- <el-button type="primary" @click="backLast">返回上一页</el-button> -->
					<el-button type="primary" @click="backIndex">返回首页</el-button>
				</p>
			</dl>
		</div>
	</div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {
				errFrom: "",
				errTo: "",
				time: 5,
			};
		},
		methods: {
			setTime() {
				var timer = setInterval(() => {
					this.time--;
					if (this.time <= 0) {
						clearInterval(timer);
						this.$router.push({
							path: "/",
						});
						this.$router.go(0);
					}
				}, 1000);
			},
			backIndex() {
				this.$router.push({
					path: "/",
				});
				this.$router.go(0);
			},
			backLast() {
				this.$router.push({
					path: this.errFrom,
				});
			},
		},
		created() {
			this.errFrom = this.$route.query._from;
			this.errTo = this.$route.query._to;
			this.setTime();
		},
	};
</script>

<style scoped>
	.error {
		width: 1200px;
		margin: 0 auto;
		overflow: hidden;
		text-align: center;
	}
	.error dl {
		padding-top: 30%;
		font-size: 16px;
	}
	.error dd {
		margin: 20px 0;
	}
</style>
